import { Link } from 'react-router-dom'
import { FaUser } from 'react-icons/fa'
import { useTranslation } from 'react-i18next'
import MyButton from './buttons'
import CookieManager from '../lib/CookiesManager'
import { ScreenMode, ScreenModeType } from '../pages/LoginRegisterPages'

interface LoginTooltipProps {
  onClose: () => void
  onSwitchMode: (mode: ScreenModeType) => void
}

const LoginTooltip = ({ onClose, onSwitchMode }: LoginTooltipProps) => {
  const { t } = useTranslation()

  const handleDoNotShowAgain = () => {
    onClose()
    CookieManager.setLoginHintHidden()
  }

  return (
    <div className='absolute -right-4 top-7 mt-2 w-48 px-4 pt-4 pb-0 bg-white border border-gray-300 rounded-lg shadow-lg text-sm text-anthraciteLight transform animate-fadeIn z-50'>
      <div className='absolute -top-1 border-t border-gray-300 right-6 w-3 h-3 bg-white transform rotate-45' />
      <div className='relative w-full'>
        <MyButton
          variant='redpink-anthracite'
          to='/login'
          icon={<FaUser />}
          className='text-center mx-auto w-full'
          onClick={(e: { preventDefault: () => void }) => {
            window.history.pushState({}, '', '/login')
            onSwitchMode(ScreenMode.SIGN_IN)
          }}
        >
          {t('login')}
        </MyButton>

        <p className='text-center font-medium text-xs mt-2'>
          {t('new-to-sexagogo')}
          <Link
            to='/register'
            className='text-redpink hover:underline'
            onClick={e => {
              window.history.pushState({}, '', '/register')
              onSwitchMode(ScreenMode.register)
            }}
          >
            {t('register')}
          </Link>
        </p>
        <button
          onClick={handleDoNotShowAgain}
          className='text-xs text-center w-full underline py-2 text-gray-400 hover:text-redpink transition-colors'
        >
          {t('do-not-show-again')}
        </button>
      </div>
    </div>
  )
}

export default LoginTooltip
